import { InstagramIcon } from '@shared/support/ContactIcons';

/**
 * Standard "open this Instagram profile" affordance: the Instagram glyph (brand
 * pink), clickable, opening the profile in a new tab. Use everywhere we link out
 * to a creator/brand IG profile so the pattern is consistent — no raw URLs or
 * "Профиль ↗" text labels. (A bare @handle that identifies a creator in a list
 * can stay as text; this is for the outbound-link affordance itself.)
 */
export function IgLink({ handle, size = 20 }: { handle?: string | null; size?: number }) {
  const h = (handle || '').replace(/^@+/, '').trim();
  if (!h) return null;
  return (
    <a
      href={`https://instagram.com/${h}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Instagram"
      title={`instagram.com/${h}`}
      style={{ display: 'inline-flex', alignItems: 'center', color: '#E1306C', textDecoration: 'none', flexShrink: 0 }}
    >
      <InstagramIcon size={size} />
    </a>
  );
}
